import store from '@/store/index'

export default {}

/**
 * Returns the full state object of the unit tracking module.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['units/findUnitsWidgetModule/get']
}

/**
 * Returns the sets of selected units.
 *
 * @return Object
 */
export const selectedUnitSets = () => {
  return store.getters['units/findUnitsWidgetModule/unitSelectionSets']
}

/**
 * Returns units that are selected for the specified set.
 *
 * @param set String
 *
 * @return Object
 */
export const selectedUnits = (set) => {
  if (store.getters['units/findUnitsWidgetModule/unitSelectionSets'].hasOwnProperty(set)) {
    return store.getters['units/findUnitsWidgetModule/unitSelectionSets'][set]
  } else {
    return {}
  }
}

/**
 * Returns units that are selected for the specified set as an array
 *
 * @param set String
 *
 * @return Array
 */
export const selectedUnitsAsArray = (set) => {
  if (store.getters['units/findUnitsWidgetModule/unitSelectionSets'].hasOwnProperty(set)) {
    const units = store.getters['units/findUnitsWidgetModule/unitSelectionSets'][set]
    const unitIds = Object.keys(units)
    let results = []
    unitIds.forEach(unitId => {
      results.push(units[unitId])
    })
    return results
  } else {
    return []
  }
}

/**
 * Return an array of integers of the selected units.
 *
 * @param set String
 * @returns [int]
 */
export const getSelectedUnitIds = (set) => {
  if (store.getters['units/findUnitsWidgetModule/unitSelectionSets'].hasOwnProperty(set)) {
    const units = store.getters['units/findUnitsWidgetModule/unitSelectionSets'][set]
    return Object.keys(units).map(key => parseInt(key))
  } else {
    return []
  }
}

/**
 * Returns the first selected unit in the specified set or null if none is selected.
 *
 * @param set String
 *
 * @return Object|null
 */
export const selectedUnit = (set) => {
  if (store.getters['units/findUnitsWidgetModule/unitSelectionSets'].hasOwnProperty(set)) {
    const units = store.getters['units/findUnitsWidgetModule/unitSelectionSets'][set]
    const unitIds = Object.keys(units)
    if (unitIds.length > 0) {
      return units[unitIds[0]]
    } else {
      return null
    }
  } else {
    return null
  }
}

/**
 * Returns true if the specified unit is selected within the supplied set.
 *
 * @param set String
 * @param id Integer
 *
 * @return Boolean
 */
export const isSelected = (set, id) => {
  return selectedUnits(set).hasOwnProperty(id)
}

/**
 * Returns either a client object or null depending on whether
 * queries should be made by client.
 *
 * @return Object|null
 */
export const getClient = () => {
  return store.getters['units/findUnitsWidgetModule/getClient']
}

/**
 * Load the status data of the units being tracked.
 *
 * @return Promise
 */
export const query = () => {
  return store.dispatch('units/findUnitsWidgetModule/query')
}

/**
 * Add a map or array of object units that have been selected within
 * the specified set.
 *
 * @param set String
 * @param units Array|Map
 */
export const addSelectedUnits = (set, units) => {
  store.commit('units/findUnitsWidgetModule/addSelectedUnits', { set, units })
}

/**
 * Removes an array of units from the set's list of selected units.
 * The array must contain the list units that are no longer selected.
 *
 * @param set String
 * @param units Array
 */
export const removeSelectedUnits = (set, units) => {
  store.commit('units/findUnitsWidgetModule/removeSelectedUnits', { set, units })
}

/**
 * Return all selected units
 *
 * @param set
 * @returns {*}
 */
export const unitSelectionSets = (set) => {
  return store.getters['units/findUnitsWidgetModule/unitSelectionSets'][set]
}

/**
 * Clears all selected units within a specified set.
 */
export const clearSelectedUnits = (set) => {
  store.commit('units/findUnitsWidgetModule/clearSelectedUnits', set)
}

/**
 * Clears all selected units.
 */
export const clearAllSelectedUnits = () => {
  store.commit('units/findUnitsWidgetModule/clearAllSelectedUnits')
}

/**
 * Returns the selected unit count for the specified set.
 *
 * @param set String
 *
 * @return Integer
 */
export const selectedUnitCount = (set) => {
  return Object.keys(selectedUnits(set)).length
}

/**
 * Clears all units from being tracked.
 */
export const purge = () => {
  store.commit('units/findUnitsWidgetModule/purge')
}

/**
 * Sets the client for which the units should be queried.
 *
 * @param client Object|null
 */
export const setClient = (client) => {
  store.commit('units/findUnitsWidgetModule/setClient', client)
}



// WEBPACK FOOTER //
// ./src/store/units/findUnitsWidget.helpers.js